import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ingredientSections", "stepsContainer", "benefitsContainer", "tipsContainer", "imagePreview"]

  connect() {
    this.sectionIndex = this.ingredientSectionsTarget.querySelectorAll('.ingredient-section').length
    this.renumberSteps()
  }

  // Ingredient Sections
  addIngredientSection(event) {
    event.preventDefault()
    const template = `
      <div class="ingredient-section mb-4 p-3" style="background: #f8f9fa; border-radius: 8px;" data-section-index="${this.sectionIndex}">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <input type="text" name="recipe[ingredients][][section]"
                 class="form-control form-control-sm" style="max-width: 300px;"
                 placeholder="Nombre de la sección (ej: Para la preparación principal)">
          <button type="button" class="btn btn-sm btn-outline-danger"
                  data-action="recipe-form#removeIngredientSection">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="ingredient-items">
          <div class="row mb-2 ingredient-item">
            <div class="col-2">
              <input type="text" name="recipe[ingredients][][items][][amount]"
                     class="form-control form-control-sm" placeholder="Cant.">
            </div>
            <div class="col-2">
              <input type="text" name="recipe[ingredients][][items][][unit]"
                     class="form-control form-control-sm" placeholder="Unidad">
            </div>
            <div class="col-4">
              <input type="text" name="recipe[ingredients][][items][][name]"
                     class="form-control form-control-sm" placeholder="Ingrediente">
            </div>
            <div class="col-3">
              <input type="text" name="recipe[ingredients][][items][][detail]"
                     class="form-control form-control-sm" placeholder="Detalle">
            </div>
            <div class="col-1">
              <button type="button" class="btn btn-sm btn-outline-danger"
                      data-action="recipe-form#removeIngredientItem">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary mt-2"
                data-action="recipe-form#addIngredientItem">
          <i class="fas fa-plus mr-1"></i>Agregar ingrediente
        </button>
      </div>
    `
    this.ingredientSectionsTarget.insertAdjacentHTML('beforeend', template)
    this.sectionIndex++
  }

  removeIngredientSection(event) {
    event.preventDefault()
    const section = event.target.closest('.ingredient-section')
    if (section && this.ingredientSectionsTarget.querySelectorAll('.ingredient-section').length > 1) {
      section.remove()
    }
  }

  addIngredientItem(event) {
    event.preventDefault()
    const section = event.target.closest('.ingredient-section')
    const itemsContainer = section.querySelector('.ingredient-items')
    const template = `
      <div class="row mb-2 ingredient-item">
        <div class="col-2">
          <input type="text" name="recipe[ingredients][][items][][amount]"
                 class="form-control form-control-sm" placeholder="Cant.">
        </div>
        <div class="col-2">
          <input type="text" name="recipe[ingredients][][items][][unit]"
                 class="form-control form-control-sm" placeholder="Unidad">
        </div>
        <div class="col-4">
          <input type="text" name="recipe[ingredients][][items][][name]"
                 class="form-control form-control-sm" placeholder="Ingrediente">
        </div>
        <div class="col-3">
          <input type="text" name="recipe[ingredients][][items][][detail]"
                 class="form-control form-control-sm" placeholder="Detalle">
        </div>
        <div class="col-1">
          <button type="button" class="btn btn-sm btn-outline-danger"
                  data-action="recipe-form#removeIngredientItem">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    `
    itemsContainer.insertAdjacentHTML('beforeend', template)
  }

  removeIngredientItem(event) {
    event.preventDefault()
    const item = event.target.closest('.ingredient-item')
    const section = event.target.closest('.ingredient-section')
    if (item && section.querySelectorAll('.ingredient-item').length > 1) {
      item.remove()
    }
  }

  // Steps
  addStep(event) {
    event.preventDefault()
    const steps = this.stepsContainerTarget.querySelectorAll('.step-item')
    const newNumber = steps.length + 1
    const template = `
      <div class="step-item d-flex mb-3" data-step-number="${newNumber}">
        <div class="step-number d-flex align-items-center justify-content-center mr-3"
             style="width: 36px; height: 36px; background: #33A036; color: white; border-radius: 50%; font-weight: bold; flex-shrink: 0;">
          ${newNumber}
        </div>
        <div class="flex-grow-1">
          <input type="hidden" name="recipe[steps][][number]" value="${newNumber}">
          <textarea name="recipe[steps][][text]" class="form-control" rows="2"
                    placeholder="Describe el paso..."></textarea>
        </div>
        <button type="button" class="btn btn-sm btn-outline-danger ml-2"
                data-action="recipe-form#removeStep">
          <i class="fas fa-times"></i>
        </button>
      </div>
    `
    this.stepsContainerTarget.insertAdjacentHTML('beforeend', template)
  }

  removeStep(event) {
    event.preventDefault()
    const step = event.target.closest('.step-item')
    const steps = this.stepsContainerTarget.querySelectorAll('.step-item')
    if (step && steps.length > 1) {
      step.remove()
      this.renumberSteps()
    }
  }

  renumberSteps() {
    const steps = this.stepsContainerTarget.querySelectorAll('.step-item')
    steps.forEach((step, index) => {
      const number = index + 1
      step.querySelector('.step-number').textContent = number
      step.querySelector('input[name*="[number]"]').value = number
    })
  }

  // Benefits
  addBenefit(event) {
    event.preventDefault()
    // Remove placeholder text if exists
    const placeholder = this.benefitsContainerTarget.querySelector('p.text-muted')
    if (placeholder) placeholder.remove()

    const template = `
      <div class="benefit-item row mb-2">
        <div class="col-3">
          <input type="text" name="recipe[benefits][][ingredient]"
                 class="form-control form-control-sm"
                 placeholder="Ingrediente">
        </div>
        <div class="col-8">
          <input type="text" name="recipe[benefits][][benefit]"
                 class="form-control form-control-sm"
                 placeholder="Beneficio (ej: Aporta proteínas de alta calidad...)">
        </div>
        <div class="col-1">
          <button type="button" class="btn btn-sm btn-outline-danger"
                  data-action="recipe-form#removeBenefit">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    `
    this.benefitsContainerTarget.insertAdjacentHTML('beforeend', template)
  }

  removeBenefit(event) {
    event.preventDefault()
    const item = event.target.closest('.benefit-item')
    if (item) item.remove()
  }

  // Tips
  addTip(event) {
    event.preventDefault()
    // Remove placeholder text if exists
    const placeholder = this.tipsContainerTarget.querySelector('p.text-muted')
    if (placeholder) placeholder.remove()

    const template = `
      <div class="tip-item d-flex mb-2">
        <input type="text" name="recipe[tips][]"
               class="form-control form-control-sm flex-grow-1"
               placeholder="Tip o variación...">
        <button type="button" class="btn btn-sm btn-outline-danger ml-2"
                data-action="recipe-form#removeTip">
          <i class="fas fa-times"></i>
        </button>
      </div>
    `
    this.tipsContainerTarget.insertAdjacentHTML('beforeend', template)
  }

  removeTip(event) {
    event.preventDefault()
    const item = event.target.closest('.tip-item')
    if (item) item.remove()
  }

  // Image preview
  previewImage(event) {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const previewContainer = this.imagePreviewTarget
        previewContainer.style.display = 'block'
        previewContainer.querySelector('img').src = e.target.result
      }
      reader.readAsDataURL(file)

      // Update label
      const label = event.target.nextElementSibling
      if (label) {
        label.textContent = file.name
      }
    }
  }
}
